import React from 'react';

import { useAuthStore } from '@store/authStore';

const GuestRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();

  return isAuthenticated ? children : <div></div>;
};

export default GuestRoute;
